module.exports = "/lucky-balls/img/drum/drum_loop_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_022.png
// module id = 1037
// module chunks = 0